export type PropertyPermissionAttribute =
  | "allow_pets"
  | "water_included"
  | "gas_included"
  | "is_adm";

export type PropertyPermissionFlags = Record<PropertyPermissionAttribute, boolean>;

export type PropertyPermissionSetters = Record<
  PropertyPermissionAttribute,
  (value: number) => void
>;

function isPermissionAttribute(
  attributeName: string
): attributeName is PropertyPermissionAttribute {
  return (
    attributeName === "allow_pets" ||
    attributeName === "water_included" ||
    attributeName === "gas_included" ||
    attributeName === "is_adm"
  );
}

export function getPropertyPermissionYes(
  flags: PropertyPermissionFlags,
  attributeName: string
): boolean {
  if (!isPermissionAttribute(attributeName)) return false;
  return flags[attributeName];
}

export function setPropertyPermissionValue(
  setters: PropertyPermissionSetters,
  attributeName: string,
  value: number
): void {
  if (!isPermissionAttribute(attributeName)) return;
  setters[attributeName](value);
}
